import { useAlertBasic } from "@/hooks/common";
import { HttpError } from "@/http/lib";
import { App } from "vue";
import { tFactory } from "@/services/i18n";
import { ResponseError } from "@/http/lib/core/HttpClient";

const i18nT = tFactory("http.");

export const systemErrorResponseHandler = <E extends HttpError>(
  error: E,
  app?: App
) => {
  const router = app?.config.globalProperties.$router;
  const store = app?.config.globalProperties.$store;
  const { alert } = useAlertBasic();
  if (error.response) {
    const status = error.response.status;
    if (status === 403) {
      const tips = i18nT("NoAccess");
      alert(tips);
    } else if (status !== 488) {
      const tips = i18nT("unknownErrorPleaseTryAgainLater");
      alert(tips);
    }
  } else {
    if (!error.isCancel()) {
      const tips = i18nT("networkError");
      alert(tips);
    }
  }
};
